export default __webpack_public_path__ + "static/icon-35-2-30549022083af02f8cb08c11d85bd372.png";